import React, { useState } from "react";
import { ChevronDownIcon, ChevronRightIcon, EditIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Textarea,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useDisclosure,
  HStack,
  Center,
  Radio,
  Divider,
  Stack,
  Image,
} from "@chakra-ui/react";
import { BsBoxArrowInLeft } from "react-icons/bs";
import { ButtonMenuFooter } from "./styles";
import { ModalContatos } from "./ComponentsModal/ModalContatos";
import { ModalPedidos } from "./ComponentsModal/ModalPedidos";
import { ModalOrcamentos } from "./ComponentsModal/ModalOrcamentos";
import { ModalFinanceiro } from "./ComponentsModal/ModalFinanceiro";
import { ModalObservacao } from "./ComponentsModal/ModalObservacao";
import { ModalInteracao } from "./ComponentsModal/ModalInteracao";
import { ModalHistoricoAlteracao } from "./ComponentsModal/ModalHistoricoAlteracao";
import { IoIosAddCircleOutline } from "react-icons/io";
import { MdOutlineSaveAlt } from "react-icons/md";
import Moment from "moment";
import { ModalOrcamentoPedido } from "./ComponentsModal/ModalOrcamentoPedido";

const loading = "../../images/loading-verde.gif";

export const ModalEditarParceiros = (dados) => {
  const OverlayTwo = () => (
    <ModalOverlay
      bg="none"
      backdropFilter="auto"
      backdropInvert="80%"
      backdropBlur="2px"
    />
  );
  const [overlay, setOverlay] = useState(<OverlayTwo />);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [abaContatos, setAbaContatos] = useState(false);
  const [abaPedidos, setAbaPedidos] = useState(false);
  const [abaOrcamentos, setAbaOrcamentos] = useState(false);
  const [abaFinanceiro, setAbaFinanceiro] = useState(false);
  const [abaObservacao, setAbaObservacao] = useState(false);
  const [abaInteracao, setAbaInteracao] = useState(false);
  const [abaHistoricoAlteracao, setAbaHistoricoAlteracao] = useState(false);
  const [abaOrcamentoPedido, setAbaOrcamentoPedido] = useState(false);

  const SetAbaHidden = () => {
    setAbaContatos(false);
    setAbaPedidos(false);
    setAbaOrcamentos(false);
    setAbaFinanceiro(false);
    setAbaObservacao(false);
    setAbaInteracao(false);
    setAbaOrcamentoPedido(false);
    setAbaHistoricoAlteracao(false);
  };

  const cadastro = Moment(dados.data.data_cadastro_parceiro).format(
    "YYYY-MM-DD"
  );
  const alteracao = Moment(dados.data.data_alteracao_parceiro).format(
    "YYYY-MM-DD"
  );

  return (
    <>
      <Button
        variant="link"
        leftIcon={<EditIcon color="#03a9f4" />}
        color="#03a9f4"
        boxShadow="none !important"
        onClick={() => {
          setOverlay(<OverlayTwo />);
          onOpen();
        }}
      >
        {!dados.visualizar ? "Editar" : "Visualizar"}
      </Button>

      <Modal isOpen={isOpen} size={"7xl"} onClose={onClose}>
        {overlay}
        <ModalOverlay />
        <ModalContent>
          {dados.loading ? (
            <Box
              w="100%"
              h="100%"
              position="absolute"
              zIndex="99999"
              bgColor="white"
            >
              <Center mt="6rem" mb="4rem">
                <Image alt="loading" src={loading} />
              </Center>
            </Box>
          ) : (
            <></>
          )}
          <ModalHeader>
            <Flex>
              <Text color="#03a9f4" fontFamily="Akrobat">
                Vendedor:
              </Text>
              <Text ml="1rem" color="gray" fontFamily="Akrobat">
                {dados.data.nome_vendedor}
              </Text>
            </Flex>
          </ModalHeader>
          <ModalCloseButton
            _hover={{ bgColor: "#d6eef7" }}
            boxShadow="none !important"
            color="#03a9f4"
          />
          <ModalBody>
            <Box w="100%">
              <Flex>
                <Text
                  color="#03a9f4"
                  fontFamily="Akrobat ExtraBold"
                  mt="0.2rem"
                >
                  Cód:
                </Text>
                <Input
                  focusBorderColor="#03a9f4"
                  bgColor="#F0F4F5"
                  size="sm"
                  w="20%"
                  ml="0.3rem"
                  value={
                    dados.data.codigo_parceiro === null
                      ? "Sem Informação"
                      : dados.data.codigo_parceiro
                  }
                />
                <Radio
                  colorScheme="twitter"
                  borderColor="#03a9f4"
                  ml="1.5rem"
                  size="lg"
                  isChecked={dados.data.cliente_especial == "S" ? true : false}
                  checked={dados.data.cliente_especial == "S" ? true : false}
                  value={dados.data.cliente_especial}
                  onClick={(e) =>
                    dados.changeValueField(
                      e,
                      dados.data,
                      "input_bool",
                      "cliente_especial"
                    )
                  }
                >
                  Cliente Especial
                </Radio>
                <Flex ml="2rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Data do Cadastro:
                  </Text>
                  <Input
                    value={cadastro == null ? "Sem Informação" : cadastro}
                    type="date"
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="60%"
                    ml="0.3rem"
                  />
                </Flex>
              </Flex>
              <Flex mt="0.5rem">
                <Text
                  color="#03a9f4"
                  fontFamily="Akrobat ExtraBold"
                  mt="0.2rem"
                >
                  CNPJ/CPF:
                </Text>
                <Input
                  value={
                    dados.data.cpf_cnpj_parceiro == null
                      ? "Sem Informação"
                      : dados.data.cpf_cnpj_parceiro
                  }
                  focusBorderColor="#03a9f4"
                  bgColor="#F0F4F5"
                  size="sm"
                  w="18.1%"
                  ml="0.3rem"
                  onChange={(e) =>
                    dados.changeValueField(
                      e,
                      dados.data,
                      "input",
                      "cpf_cnpj_parceiro"
                    )
                  }
                />
              </Flex>
              <Flex mt="1rem">
                <Button
                  w="220px"
                  boxShadow="none !important"
                  _hover={{ opacity: 0.9 }}
                  size="sm"
                  bgColor="#03a9f4"
                  color="white"
                >
                  CONSULTAR RECEITA FEDERAL
                </Button>
                <Button
                  w="220px"
                  ml="1rem"
                  boxShadow="none !important"
                  _hover={{ opacity: 0.9 }}
                  size="sm"
                  bgColor="#03a9f4"
                  color="white"
                >
                  CONSULTAR SINTEGRA
                </Button>
              </Flex>
            </Box>
            <Flex h="330px">
              <Box w="50%">
                <Flex mt="1rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Nome Parceiro:
                  </Text>
                  <Input
                    value={
                      dados.data.nome_parceiro == null
                        ? "Sem Informação"
                        : dados.data.nome_parceiro
                    }
                    onChange={(e) =>
                      dados.changeValueField(
                        e,
                        dados.data,
                        "input",
                        "nome_parceiro"
                      )
                    }
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="72.8%"
                    ml="0.3rem"
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Razão Social:
                  </Text>
                  <Input
                    value={
                      dados.data.razao_social_parceiro == null
                        ? "Sem Informação"
                        : dados.data.razao_social_parceiro
                    }
                    onChange={(e) =>
                      dados.changeValueField(
                        e,
                        dados.data,
                        "input",
                        "razao_social_parceiro"
                      )
                    }
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="74.3%"
                    ml="0.3rem"
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Insc. Estadual/Identidade:
                  </Text>
                  <Input
                    value={
                      dados.data.inscricao_estadual_parceiro == null
                        ? "Sem Informação"
                        : dados.data.inscricao_estadual_parceiro
                    }
                    onChange={(e) =>
                      dados.changeValueField(
                        e,
                        dados.data,
                        "input",
                        "inscricao_estadual_parceiro"
                      )
                    }
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="66%"
                    ml="0.3rem"
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    mt="0.2rem"
                    fontFamily="Akrobat ExtraBold"
                  >
                    Classificação ICMS:
                  </Text>
                  <Select
                    ml="0.3rem"
                    focusBorderColor="#03a9f4"
                    iconColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="18%"
                    onChange={(e) =>
                      dados.changeValueField(
                        e,
                        dados.data,
                        "select",
                        "id_classificacao_parceiro"
                      )
                    }
                    value={dados.data.id_classificacao_parceiro}
                  >
                    <option value={"X"}>Contribuinte</option>
                    <option value={"C"}>Não Contribuinte</option>
                  </Select>
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Tipo de Pessoa:
                  </Text>
                  <Select
                    ml="0.3rem"
                    focusBorderColor="#03a9f4"
                    iconColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="10%"
                    value={dados.data.desc_tipo_pessoa}
                    onChange={(e) =>
                      dados.changeValueField(
                        e,
                        dados.data,
                        "select",
                        "id_tipo_pessoa"
                      )
                    }
                  >
                    <option value={"F"}>Física</option>
                    <option value={"J"}>Jurídica</option>
                  </Select>
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Contrato:
                  </Text>
                  <Input
                    value={
                      dados.data.numero_contrato_parceiro == null
                        ? "Sem Informação"
                        : dados.data.numero_contrato_parceiro
                    }
                    onChange={(e) =>
                      dados.changeValueField(
                        e,
                        dados.data,
                        "input",
                        "numero_contrato_parceiro"
                      )
                    }
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="76.8%"
                    ml="0.3rem"
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Data Alteração Plataforma:
                  </Text>
                  <Input
                    value={alteracao == null ? "Sem Informação" : alteracao}
                    type="date"
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="20%"
                    ml="0.3rem"
                  />
                </Flex>
              </Box>
              <Box w="50%">
                <Flex mt="1rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Endereço:
                  </Text>
                  <Input
                    value={
                      dados.data.endereco_parceiro == null
                        ? "Sem Informação"
                        : dados.data.endereco_parceiro
                    }
                    focusBorderColor="#03a9f4"
                    w="77%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    CEP:
                  </Text>
                  <Input
                    value={
                      dados.data.cep_parceiro == null
                        ? "Sem Informação"
                        : dados.data.cep_parceiro
                    }
                    onChange={(e) =>
                      dados.changeValueField(
                        e,
                        dados.data,
                        "input",
                        "cep_parceiro"
                      )
                    }
                    focusBorderColor="#03a9f4"
                    w="11%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                  <Text
                    ml="1rem"
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Número:
                  </Text>
                  <Input
                    value={
                      dados.data.numero_endereco_parceiro == null
                        ? "Sem Informação"
                        : dados.data.numero_endereco_parceiro
                    }
                    onChange={(e) =>
                      dados.changeValueField(
                        e,
                        dados.data,
                        "input",
                        "numero_endereco_parceiro"
                      )
                    }
                    focusBorderColor="#03a9f4"
                    w="10%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Complemento:
                  </Text>
                  <Input
                    value={
                      dados.data.complemento_parceiro == null
                        ? "Sem Informação"
                        : dados.data.complemento_parceiro
                    }
                    onChange={(e) =>
                      dados.changeValueField(
                        e,
                        dados.data,
                        "input",
                        "complemento_parceiro"
                      )
                    }
                    focusBorderColor="#03a9f4"
                    w="74.2%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Bairro:
                  </Text>
                  <Input
                    value={
                      dados.data.bairro_parceiro == null
                        ? "Sem Informação"
                        : dados.data.bairro_parceiro
                    }
                    focusBorderColor="#03a9f4"
                    w="79.1%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Cidade:
                  </Text>
                  <Input
                    value={
                      dados.data.cidade_parceiro == null
                        ? "Sem Informação"
                        : dados.data.cidade_parceiro
                    }
                    focusBorderColor="#03a9f4"
                    w="30%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                  <Text
                    ml="1rem"
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Estado:
                  </Text>
                  <Input
                    value={
                      dados.data.estado_parceiro == null
                        ? "Sem Informação"
                        : dados.data.estado_parceiro
                    }
                    focusBorderColor="#03a9f4"
                    w="30%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                </Flex>

                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    E-mail p/ envio NF-e/NFS-e/CT-e:
                  </Text>
                  <Textarea
                    value={
                      dados.data.email_parceiro == null
                        ? "Sem Informação"
                        : dados.data.email_parceiro
                    }
                    onChange={(e) =>
                      dados.changeValueField(
                        e,
                        dados.data,
                        "input",
                        "email_parceiro"
                      )
                    }
                    w="49.1%"
                    focusBorderColor="#03a9f4"
                    resize="none"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                  {!dados.visualizar ? (
                    <Flex flexDirection="column">
                      <Button
                        size="sm"
                        bgColor="#03a9f4"
                        leftIcon={
                          <IoIosAddCircleOutline color="white" size="25px" />
                        }
                        ml="1.5rem"
                        color="white"
                        _hover={{ opacity: 0.8 }}
                        boxShadow="none !important"
                      >
                        E-mail
                      </Button>
                      <Button
                        mt="1rem"
                        size="sm"
                        bgColor="#ff9045"
                        leftIcon={
                          <MdOutlineSaveAlt color="white" size="25px" />
                        }
                        ml="1.5rem"
                        color="white"
                        _hover={{ opacity: 0.9 }}
                        boxShadow="none !important"
                        onClick={() => dados.saveDataClient(dados.data)}
                      >
                        Salvar
                      </Button>
                    </Flex>
                  ) : (
                    <></>
                  )}
                </Flex>
              </Box>
            </Flex>
            <Center>
              <HStack fontFamily="Akrobat ExtraBold" spacing={10}>
                <Flex gap={2} flexWrap="wrap">
                  <ButtonMenuFooter
                    rightIcon={
                      abaContatos ? (
                        <ChevronDownIcon color="#03a9f4" size="25px" />
                      ) : (
                        <ChevronRightIcon color="#03a9f4" size="25px" />
                      )
                    }
                    style={abaContatos ? { backgroundColor: "#d6eef7" } : {}}
                    color="#03a9f4"
                    _hover={{ bgColor: "#d6eef7" }}
                    _active={{ bgColor: "#d6eef7" }}
                    variant="ghost"
                    boxShadow="none !important"
                    onClick={() => {
                      SetAbaHidden();
                      setAbaContatos(true);
                    }}
                  >
                    Contatos
                  </ButtonMenuFooter>
                  <Stack direction="row" h="40px">
                    <Divider orientation="vertical" />
                  </Stack>
                  <ButtonMenuFooter
                    rightIcon={
                      abaPedidos ? (
                        <ChevronDownIcon color="#03a9f4" size="25px" />
                      ) : (
                        <ChevronRightIcon color="#03a9f4" size="25px" />
                      )
                    }
                    style={abaPedidos ? { backgroundColor: "#d6eef7" } : {}}
                    color="#03a9f4"
                    _hover={{ bgColor: "#d6eef7" }}
                    _active={{ bgColor: "#d6eef7" }}
                    variant={abaPedidos ? "outline" : ""}
                    boxShadow="none !important"
                    onClick={() => {
                      SetAbaHidden();
                      setAbaPedidos(true);
                    }}
                  >
                    Pedidos
                  </ButtonMenuFooter>
                  <Stack direction="row" h="40px">
                    <Divider orientation="vertical" />
                  </Stack>
                  <ButtonMenuFooter
                    rightIcon={
                      abaOrcamentos ? (
                        <ChevronDownIcon color="#03a9f4" size="25px" />
                      ) : (
                        <ChevronRightIcon color="#03a9f4" size="25px" />
                      )
                    }
                    style={abaOrcamentos ? { backgroundColor: "#d6eef7" } : {}}
                    color="#03a9f4"
                    _hover={{ bgColor: "#d6eef7" }}
                    _active={{ bgColor: "#d6eef7" }}
                    variant="ghost"
                    boxShadow="none !important"
                    onClick={() => {
                      SetAbaHidden();
                      setAbaOrcamentos(true);
                    }}
                  >
                    Orçamentos
                  </ButtonMenuFooter>
                  <Stack direction="row" h="40px">
                    <Divider orientation="vertical" />
                  </Stack>
                  <ButtonMenuFooter
                    rightIcon={
                      abaFinanceiro ? (
                        <ChevronDownIcon color="#03a9f4" size="25px" />
                      ) : (
                        <ChevronRightIcon color="#03a9f4" size="25px" />
                      )
                    }
                    style={abaFinanceiro ? { backgroundColor: "#d6eef7" } : {}}
                    color="#03a9f4"
                    _hover={{ bgColor: "#d6eef7" }}
                    _active={{ bgColor: "#d6eef7" }}
                    variant="ghost"
                    boxShadow="none !important"
                    onClick={() => {
                      SetAbaHidden();
                      setAbaFinanceiro(true);
                    }}
                  >
                    Financeiro
                  </ButtonMenuFooter>
                  <Stack direction="row" h="40px">
                    <Divider orientation="vertical" />
                  </Stack>
                  <ButtonMenuFooter
                    rightIcon={
                      abaObservacao ? (
                        <ChevronDownIcon color="#03a9f4" size="25px" />
                      ) : (
                        <ChevronRightIcon color="#03a9f4" size="25px" />
                      )
                    }
                    style={abaObservacao ? { backgroundColor: "#d6eef7" } : {}}
                    color="#03a9f4"
                    _hover={{ bgColor: "#d6eef7" }}
                    _active={{ bgColor: "#d6eef7" }}
                    variant="ghost"
                    boxShadow="none !important"
                    onClick={() => {
                      SetAbaHidden();
                      setAbaObservacao(true);
                    }}
                  >
                    Observação
                  </ButtonMenuFooter>
                  <Stack direction="row" h="40px">
                    <Divider orientation="vertical" />
                  </Stack>
                  <ButtonMenuFooter
                    rightIcon={
                      abaInteracao ? (
                        <ChevronDownIcon color="#03a9f4" size="25px" />
                      ) : (
                        <ChevronRightIcon color="#03a9f4" size="25px" />
                      )
                    }
                    style={abaInteracao ? { backgroundColor: "#d6eef7" } : {}}
                    color="#03a9f4"
                    _hover={{ bgColor: "#d6eef7" }}
                    _active={{ bgColor: "#d6eef7" }}
                    variant="ghost"
                    boxShadow="none !important"
                    onClick={() => {
                      SetAbaHidden();
                      setAbaInteracao(true);
                    }}
                  >
                    Interação / Agendar retorno
                  </ButtonMenuFooter>
                  <Stack direction="row" h="40px">
                    <Divider orientation="vertical" />
                  </Stack>
                  <ButtonMenuFooter
                    rightIcon={
                      abaInteracao ? (
                        <ChevronDownIcon color="#03a9f4" size="25px" />
                      ) : (
                        <ChevronRightIcon color="#03a9f4" size="25px" />
                      )
                    }
                    style={abaInteracao ? { backgroundColor: "#d6eef7" } : {}}
                    color="#03a9f4"
                    _hover={{ bgColor: "#d6eef7" }}
                    _active={{ bgColor: "#d6eef7" }}
                    variant="ghost"
                    boxShadow="none !important"
                    onClick={() => {
                      SetAbaHidden();
                      setAbaOrcamentoPedido(true);
                    }}
                  >
                    Orçamento/Pedido
                  </ButtonMenuFooter>
                  <Stack direction="row" h="40px">
                    <Divider orientation="vertical" />
                  </Stack>
                  <ButtonMenuFooter
                    rightIcon={
                      abaHistoricoAlteracao ? (
                        <ChevronDownIcon color="#03a9f4" size="25px" />
                      ) : (
                        <ChevronRightIcon color="#03a9f4" size="25px" />
                      )
                    }
                    style={
                      abaHistoricoAlteracao
                        ? { backgroundColor: "#d6eef7" }
                        : {}
                    }
                    color="#03a9f4"
                    _hover={{ bgColor: "#d6eef7" }}
                    _active={{ bgColor: "#d6eef7" }}
                    variant="ghost"
                    boxShadow="none !important"
                    onClick={() => {
                      SetAbaHidden();
                      setAbaHistoricoAlteracao(true);
                    }}
                  >
                    Histórico de Alteração
                  </ButtonMenuFooter>
                </Flex>
              </HStack>
            </Center>
            {abaOrcamentoPedido ? (
              <ModalOrcamentoPedido
                data={dados}
                visualizar={dados.visualizar}
              />
            ) : (
              <></>
            )}
            {abaContatos ? (
              <ModalContatos
                data={dados}
                insertNewContact={dados.insertNewContact}
                deleteContact={dados.deleteContact}
                visualizar={dados.visualizar}
              />
            ) : (
              <></>
            )}
            {abaPedidos ? (
              <ModalPedidos data={dados} visualizar={dados.visualizar} />
            ) : (
              <></>
            )}
            {abaOrcamentos ? (
              <ModalOrcamentos data={dados} visualizar={dados.visualizar} />
            ) : (
              <></>
            )}
            {abaFinanceiro ? (
              <ModalFinanceiro visualizar={dados.visualizar} />
            ) : (
              <></>
            )}
            {abaObservacao ? (
              <ModalObservacao visualizar={dados.visualizar} />
            ) : (
              <></>
            )}
            {abaInteracao ? (
              <ModalInteracao
                historico={dados.data.historico_tmk}
                funilVendas={dados.funilVendas}
                motivoPerda={dados.motivoPerda}
                enviarTMK={dados.enviarTMK}
                visualizar={dados.visualizar}
              />
            ) : (
              <></>
            )}
            {abaHistoricoAlteracao ? (
              <ModalHistoricoAlteracao
                historico={dados.data.historico_alteracao}
                visualizar={dados.visualizar}
              />
            ) : (
              <></>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              leftIcon={<BsBoxArrowInLeft size="25px" />}
              bgColor="#03a9f4"
              _hover={{ backgroundColor: "#03a9f4", opacity: "0.9" }}
              color="white"
              mr={3}
              onClick={onClose}
            >
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
